import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Box from './Box';
import Code from './Code';
import Wrapper from './Wrapper';

function MultipleDemo({ translateX, rotation, variant }) {
  const transform =
    variant === 'multiple'
      ? `translateX(${translateX}px) rotate(${rotation}deg)`
      : `rotate(${rotation}deg) translateX(${translateX}px)`;

  const styles = useSpring({
    transform,
  });

  return (
    <Wrapper>
      <Box style={styles}></Box>
      <Code>transform: {transform};</Code>
    </Wrapper>
  );
}

export default MultipleDemo;
